import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center mb-40"
}
const _hoisted_2 = { class: "text-35 mb-40" }
const _hoisted_3 = { key: "resendResetEmailDone" }
const _hoisted_4 = { class: "mt-100" }
const _hoisted_5 = { key: "resendResetEmail" }
const _hoisted_6 = { class: "mb-40" }
const _hoisted_7 = { class: "text-35 text-center mb-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link_conditional = _resolveComponent("router-link-conditional")!
  const _component_Recaptcha = _resolveComponent("Recaptcha")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ConfirmationButton = _resolveComponent("ConfirmationButton")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_Transition, {
      name: "o-anim-fade-1000",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.showConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.confirmationTitle), 1),
              (_ctx.isResetSuccessConfirmation)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.loginLink.url)
                      ? (_openBlock(), _createBlock(_component_router_link_conditional, {
                          key: 0,
                          class: "c-magic-line c-magic-line--underline inline-block text-18",
                          to: _ctx.loginLink.url,
                          "spa-enabled": _ctx.loginLink.spaLink,
                          title: _ctx.labels.resetpasswordsubmitdonelink
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.labels.resetpasswordsubmitdonelink), 1)
                          ]),
                          _: 1
                        }, 8, ["to", "spa-enabled", "title"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createBlock(_Transition, {
                    key: 1,
                    name: "o-anim-fade-400",
                    mode: "out-in"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.resendResetEmailDone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.labels.resetpasswordresendemailconfirmation), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_Form, { onSubmit: _ctx.verifyRecaptcha }, {
                              default: _withCtx(({ isSubmitting, handleSubmit }) => [
                                _createVNode(_component_Recaptcha, {
                                  ref: "recaptcha",
                                  modelValue: _ctx.recaptchaKey,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recaptchaKey) = $event)),
                                  onVerify: ($event: any) => (handleSubmit(_ctx.resendResetEmail))
                                }, null, 8, ["modelValue", "onVerify"]),
                                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.labels.resetpasswordresendemailtitle), 1),
                                _createVNode(_component_InputText, {
                                  name: "email",
                                  label: _ctx.labels.resetpasswordresendemaillabel,
                                  type: "text",
                                  autocomplete: "new-password",
                                  rules: _ctx.formValidation.email,
                                  class: "text-left text-14 lg:text-16 xl:text-18"
                                }, null, 8, ["label", "rules"]),
                                _createVNode(_component_ConfirmationButton, {
                                  class: "w-full",
                                  confirm: isSubmitting,
                                  "animation-duration": _ctx.confirmationAnimationTiming,
                                  text: _ctx.labels.resetpasswordresendemailbutton,
                                  "confirmation-text": _ctx.labels.resetpasswordresendemailbuttonpending
                                }, null, 8, ["confirm", "animation-duration", "text", "confirmation-text"])
                              ]),
                              _: 1
                            }, 8, ["onSubmit"])
                          ]))
                    ]),
                    _: 1
                  }))
            ]))
          : (_openBlock(), _createBlock(_component_Form, {
              key: 1,
              onSubmit: _ctx.reset
            }, {
              default: _withCtx(({ isSubmitting }) => [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.labels.resetpasswordtitle), 1),
                _createVNode(_component_InputText, {
                  name: "password",
                  label: _ctx.labels.resetpasswordfieldlabel,
                  type: "password",
                  autocomplete: "new-password",
                  "input-clear": false,
                  rules: _ctx.formValidation.password,
                  class: "text-14 lg:text-16 xl:text-18"
                }, null, 8, ["label", "rules"]),
                _createVNode(_component_InputText, {
                  name: "passwordConfirm",
                  label: _ctx.labels.resetpasswordrepeatfieldlabel,
                  type: "password",
                  autocomplete: "new-password",
                  "input-clear": false,
                  rules: _ctx.formValidation.passwordConfirm,
                  class: "text-14 lg:text-16 xl:text-18"
                }, null, 8, ["label", "rules"]),
                _createVNode(_component_ConfirmationButton, {
                  class: "w-full",
                  confirm: isSubmitting,
                  "animation-duration": _ctx.confirmationAnimationTiming,
                  text: _ctx.labels.resetpasswordsubmit,
                  "confirmation-text": _ctx.labels.resetpasswordsubmitconfirm
                }, null, 8, ["confirm", "animation-duration", "text", "confirmation-text"])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
      ]),
      _: 1
    })
  ]))
}